module.exports = __webpack_public_path__ + "static/rcc-knb61-dor-badge-cd3eb6e9d2d08e15cc337ef84b041dec.png";